var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("path", {
          attrs: {
            opacity: "0.4",
            d: "M22 7.43018V13.4302C22 14.9302 21.5 16.1802 20.62 17.0602C19.75 17.9302 18.5 18.4302 17 18.4302V20.5602C17 21.3602 16.11 21.8402 15.45 21.4002L11 18.4302H8.88C8.96 18.1302 9 17.8202 9 17.5002C9 16.4802 8.61 15.5402 7.97 14.8302C7.25 14.0102 6.18 13.5002 5 13.5002C3.88 13.5002 2.86 13.9602 2.13 14.7102C2.04 14.3102 2 13.8802 2 13.4302V7.43018C2 4.43018 4 2.43018 7 2.43018H17C20 2.43018 22 4.43018 22 7.43018Z",
            stroke: "#F09A0FFF",
            "stroke-width": "1.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M9 17.5C9 18.25 8.79001 18.96 8.42001 19.56C8.21001 19.92 7.94 20.24 7.63 20.5C6.93 21.13 6.01 21.5 5 21.5C3.54 21.5 2.26999 20.72 1.57999 19.56C1.20999 18.96 1 18.25 1 17.5C1 16.24 1.58 15.11 2.5 14.38C3.19 13.83 4.06 13.5 5 13.5C7.21 13.5 9 15.29 9 17.5Z",
            stroke: "#F09A0FFF",
            "stroke-width": "1.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M3.43945 17.5L4.42944 18.49L6.55945 16.52",
            stroke: "#F09A0FFF",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M8.5 10.5H15.5",
            stroke: "#F09A0FFF",
            "stroke-width": "1.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }